import { BaseService } from "./BaseService";
import { CommandService } from "./CommandService";
import { IDataRequestOption, IComboboxRequestParameter, IMultipleControlRequestParameter, IDataRow, IODataResult } from "Entities";
import { Configuration } from "Configuration";

/**
 * Service for requesting comboboxdata.
 * @hidden
 */
export class ComboboxService extends BaseService {
    private controllerName: string = "combobox";

    /**
     * Get data for all comboboxes in an EditContext.
     * @param gridId Id of the grid.
     * @param options List of request options.
     * @param dataRow Current datarow in grid / form.
     */
    public getAll(gridId: number, options: IDataRequestOption[], dataRow: IDataRow): Promise<{ [controlID: number]: IODataResult }> {
        let param = <IMultipleControlRequestParameter>$.extend(CommandService.getRequestParameters(), { DataRow: dataRow }, { DataRequestOptions: options });
        return this.post(`${Configuration.baseUrl}${this.controllerName}/${gridId}`, param);
    }

    /**
     * Get data for a single combobox.
     * @param gridId Id of the grid.
     * @param controlId Id of the combobox control.
     * @param option Request option.
     * @param dataRow Current datarow in grid / form.
     */
    public get(gridId: number, controlId: number, option: IDataRequestOption, dataRow: IDataRow): Promise<IODataResult> {
        let param = <IComboboxRequestParameter>$.extend(CommandService.getRequestParameters(), { DataRow: dataRow }, { DataRequestOption: option });
        return this.post(`${Configuration.baseUrl}${this.controllerName}/${gridId}/${controlId}`, param);
    }

    /**
     * Get the index of an item in the combobox. Used for async comboboxes.
     * @param gridId Id of the grid.
     * @param controlId Id of the combobox control.
     * @param option Request option.
     * @param dataRow Current datarow in grid / form.
     */
    public mapValue(gridId: number, controlId: number, option: IDataRequestOption, dataRow: IDataRow): Promise<IODataResult> {
        let param = <IComboboxRequestParameter>$.extend(CommandService.getRequestParameters(), { DataRow: dataRow }, { DataRequestOption: option });
        return this.post(`${Configuration.baseUrl}${this.controllerName}/${gridId}/${controlId}/mapValue`, param); 
    }
}
